import { useModal } from "../../context/ModalContext";
import ActionModal from "./ActionModal";

const ModalLookup: any = {
  ActionModal: ActionModal
};

const ModalManager = () => {
  const { modal, closeModal }: any = useModal();

  if (!modal) return null;
  const Modal = ModalLookup[modal.name];

  return <Modal onClose={closeModal} {...modal.props} />;
};

export default ModalManager;
